// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "ExpressiveList-module--bx--text-truncate--end--3CZDm";
export var bxTextTruncateFront = "ExpressiveList-module--bx--text-truncate--front--1B-DR";
export var content = "ExpressiveList-module--content--11vqv";
export var expressive_02 = "ExpressiveList-module--expressive_02--1SiEm";
export var expressive_04 = "ExpressiveList-module--expressive_04--31mFz";
export var listRow = "ExpressiveList-module--listRow--zOcvj";
export var pictogramContent = "ExpressiveList-module--pictogramContent--3Vk9O";
export var title = "ExpressiveList-module--title--3JNU4";